import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { query } from '@/api/looker/utils/query';
import { useLookerModelId } from '@/hooks/looker/use-looker-model-id';
import { useLookerSdk } from '@/hooks/useLookerSdk';

export function useSiteIdsList(): UseQueryResult<string[]> {
  const coreSDK = useLookerSdk();
  const model = useLookerModelId();

  return useQuery({
    queryKey: ['api/looker/list-listes', model],
    async queryFn(): Promise<string[]> {
      const sites = await query(coreSDK)
        .from<{
          'frontend_id_mapping.frontend_group_id': string;
        }>({
          model,
          view: 'frontend_id_mapping',
          fields: ['frontend_id_mapping.frontend_group_id'],
          sorts: ['frontend_id_mapping.frontend_group_id asc'],
          filters: { 'frontend_id_mapping.frontend_group_id': '-NULL' },
        })
        .toMany<string>(
          (result) => result['frontend_id_mapping.frontend_group_id'],
        );

      return sites;
    },
  });
}
